<template>
  <header class="site-header">
    <div class="container">
      <a class="site-logo" @click="goIndex"><span class="logo"></span>{{ this.messages[this.lang].siteName }}</a>
      <nav class="site-nav">
        <a :href="'/api.html#/' + this.lang">{{ this.messages[this.lang].navApi }}</a>
        <a :href="'/dashboard.html#/' + this.lang">{{ this.messages[this.lang].navDashboard }}</a>
        <div class="user-info" v-if="this.$parent.isLogin">
          <i class="icon icon-user"></i><span class="username">{{ this.$parent.userName }}</span><span class="sep">|</span><a href="#" @click="goLogout">{{ this.messages[this.lang].logout }}</a>
        </div>
        <div class="user-info" v-else>
          <a href="#" @click="goLogin">{{ this.messages[this.lang].login }}</a>
        </div>
        <!--<div class="user-info">-->
          <!--<select @change="changeLang" >-->
            <!--<option value="zh" v-bind:selected="this.lang === 'zh'">中文</option>-->
            <!--<option value="en" v-bind:selected="this.lang === 'en'">EN</option>-->
            <!--<option value="ru" v-bind:selected="this.lang === 'ru'">RU</option>-->
          <!--</select>-->
        <!--</div>-->
        <div class="user-info">
          <select @change="travel">
            <option
              v-for="(item,index) in this.websites"
              v-bind:key="index" v-bind:value="item.name"
              v-bind:selected="item.name == website"
            >
              {{ item.title }}
            </option>
          </select>
        </div>
      </nav>
    </div>
  </header>
</template>
<style lang="scss" rel="stylesheet/scss">
  .site-logo{
    cursor:pointer;
  }
</style>
<script>
  export default {
    name: 'SiteHeader',
    data() {
      return {
        lang: 'zh',
        website: `${process.env.WEBSITE}`,
        websites: {
          china: {
            name: 'china',
            lang: 'zh',
            url: 'http://open.be.mi.com',
            title: '中国',
          },
          india: {
            name: 'india',
            lang: 'en',
            url: 'http://in.open.be.mi.com',
            title: 'india',
          },
          singapore: {
            name: 'singapore',
            lang: 'en',
            url: 'http://sg.open.be.mi.com',
            title: 'singapore',
          },
          russia: {
            name: 'russia',
            lang: 'en',
            url: 'http://ru.open.be.mi.com',
            title: 'russia',
          },
        },
        messages: {
          en: {
            siteName: 'XiaoMi Open API Platform',
            navApi: 'API Documentation',
            navDoc: 'Instruction',
            navDashboard: 'Console',
            login: 'Login',
            logout: 'Logout',
          },
          zh: {
            siteName: '小米网开放平台',
            navApi: 'API 文档',
            navDoc: '使用文档',
            navDashboard: '控制台',
            login: '登录',
            logout: '退出',
          },
        },
      };
    },
    methods: {
      goLogin() {
        localStorage.removeItem('apiCategoryData');
        event.preventDefault();
        location.href = `${process.env.API_URL}/${this.lang}/login?follow_up=${encodeURIComponent(location.href)}`;
      },
      goLogout() {
        localStorage.removeItem('apiCategoryData');
        event.preventDefault();
        location.href = `${process.env.API_URL}/${this.lang}/logout?follow_up=${encodeURIComponent(location.href)}`;
      },
      goIndex() {
        location.href = `${process.env.SITE_URL}/#/${this.lang}`;
      },
      changeLang(event) {
        const tmp = $(event.target).val();
        this.lang = tmp;
        localStorage.removeItem('apiCategoryData');
        localStorage.setItem('local', this.lang);
        location.href = `${process.env.SITE_URL}/#/${this.lang}`;
      },
      travel(event) {
        const name = $(event.target).val();
        const web = this.websites[name];
        this.lang = web.lang;
        const tmpHref = `${web.url}/#/${web.lang}`;
        localStorage.removeItem('apiCategoryData');
        localStorage.setItem('local', this.lang);
        location.href = tmpHref;
      },
    },
    created() {
      if (location.href.indexOf('/zh') !== -1) {
        this.lang = 'zh';
      } else {
        this.lang = 'en';
      }
    },
  };
</script>



// WEBPACK FOOTER //
// SiteHeader.vue?be37bc96